<template>
  <v-dialog v-model="dialog"
            persistent
            @keydown.esc="closeDialog"
            max-width="700px"
  >
    <v-card>
        <v-card-title style="padding-top: 15px; padding-bottom:0px;">
          <h1 class="pop_tit">{{ $t(mode === 'edit' ? 'page.meeting-reserve.edit-meeting': 'page.meeting-reserve.create-meeting') }}</h1>
          <a class="pop_close" @click="closeDialog">x</a>
            <!-- <img v-bind:src="computePageHeaderIcon" style="margin-bottom:-8px;" alt="title bar"> -->            
          <!-- <span class="headline">{{ $t('page.meeting-reserve.meeting-room') }}</span> -->
        </v-card-title>
        <!-- <div class="divider-bar"></div> -->
        <div style="margin-bottom:15px;"></div>
        <div class="divider-bar" style="background:#e9e9e9"></div>
          <v-container grid-list-xl fluid style="padding-top: 5px; padding-bottom: 5px;" >
               <!-- popContainer -->
              <div class="popContainer">
                <div class="tbw line">
                  <form>
                    <table class="tbw_p01">
                      <caption style="font-weight:bold;">예약신청</caption>
                      <tbody>
                        <tr>
                          <th>{{ $t('page.meeting-reserve.meeting-room') }}</th>
                          <td class="search_small_drop_box">
                            <div class="search_small inblk" style="line-height: 34px;">
                              <span>{{ roomName }}</span>
                              <!-- <input type="text" class="search_input" id="" name="" :value="roomName" maxlength="20" :disabled="true"> -->
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('page.meeting-reserve.meeting-name') }}</th>
                          <td>
                            <span class="input_txt">
                              <input type="text" v-model="title" :placeholder="$t('page.meeting-reserve.meeting-name')">
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('page.meeting-reserve.meeting-time') }}</th>
                          <td>
                          <!-- timetype-->
                            <div class="timetype">
                            <!--time_box -->
                            <div class="timetype">
                                <span class="fl">{{ $t('page.meeting-reserve.start-now') }}</span>
                            </div>
                            <!--//time_box -->
                            </div>
                            <!--//timetype-->
                            <!-- timetype-->
                            <div class="timetype">
                            <!--time_box -->
                              <div class="time_box">
                                <div class="time">
                                  <select class="formbox-time-select" 
                                    v-model="endTime"
                                    @change="changedEndTime">
                                    <option 
                                      v-for="(timeData) in meetingTimeList" 
                                      :key="timeData"
                                      :value="timeData">{{timeData}}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <span style="line-height:40px;font-size:12px">{{ $t('page.meeting-reserve.until') }}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>{{ $t('page.meeting-reserve.attendee') }}</th>
                          <td>
                            <!-- <span class="input_txt textcl"><input type="text" class="textcl"></span> -->
                            <span class="input_txt textcl">
                              <input type="text" :value="attendeesString" readonly @click="openMeetingInvitaionDialog()" style="color:#b4b4b4">
                            </span>
                          </td>
                        </tr>
                        <tr>
                        <th>{{ $t('page.meeting-reserve.password') }}</th>
                        <td>
                          <span class="input_txt">
                            <input v-model="meetingPW" id="pwd" name="pwd" minlength="20" value="">
                          </span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </form>
                </div>
                <div class="btn_crud" v-if="mode !== 'edit'">
                  <a :class="{ 'btn-disabled': loading , 'btn_com': true, 'small': true}" @click="submitReserve">
                    {{ !loading ? $t('page.meeting-reserve.submit-reserve') : '' }}
                    <span v-if="loading" class="spinner"></span>
                  </a>
                  <a class="btn_line small" @click="closeDialog">{{ $t('dialog.add.cancel') }}</a>
                </div>
                <div class="btn_crud" v-else>
                  <a @click="editMeeting" :class="{ 'btn-disabled': loading , 'btn_com': true, 'small': true}">
                    {{ !loading ? $t('page.meeting-reserve.save') : '' }}
                    <span v-if="loading" class="spinner"></span>
                  </a>
                  <a @click="closeDialog" class="btn_linedf small">{{ $t('dialog.add.cancel') }}</a>
                  <a @click="deleteMeeting" class="btn_gline small">{{ $t('page.meeting-reserve.delete-reserve') }}</a>
                </div>
              </div>
          </v-container>
      </v-card>
    <meeting-invitaion-dialog 
      :dialog="meetingInvitaionDialog.dialog" 
      :attendeesInfo="meetingInvitaionDialog.attendees"
      :closeDialog="closeMeetingInvitaionDialog"/>

  </v-dialog>
</template>
<script>
import Util from '@/util';
import moment from 'moment';
import MeetingInvitaionDialog from '@/components/popup/MeetingInvitaionDialog';

export default {
  components: {
    MeetingInvitaionDialog,
  },
  props: [
    'dialog',
    'closeDialog',
    'room',
    'meetingInfo',
    'isAdminPage',
    'mode'
  ],
  data () {
    return {
      title: null,
      endDate: null,
      endTime: null,
      meetingTimeList: [],
      roomName: null,
      meetingPW: null,
      meetingInvitaionDialog: {
        dialog: false,
        attendees: []
      },
      attendeesString: null,
      attendees: [],
      editRoomInfo: null,
      loading: false
    };
  },
  watch: {
    dialog: {
      handler (val) {
        this.loading = false;
        this.initMeeting();
      }
    }
  },
  methods: {
    initMeeting () {      
      if (this.mode !== 'edit') {
        this.roomName = this.room.name;
        this.initTimeData();
        this.title = null;
        this.meetingPW = null;
        this.endDate = moment().format('YYYY-MM-DD');
        this.attendees = [];
        this.attendeesString = this.$t('page.meeting-reserve.attendee-list');
      } else {
        // Get Room Name
        this.getOpenConfInfo(this.meetingInfo._id);
        this.initTimeData();
        this.title = this.meetingInfo.title;
        this.meetingPW = this.meetingInfo.meetingPW;
        this.endTime = moment(this.meetingInfo.endDtime).format('HH:mm');
        this.endDate = moment(this.meetingInfo.startDtime).format('YYYY-MM-DD');
        this.attendees = this.meetingInfo.attendees;
        this.attendeesString = this.$t('page.meeting-reserve.attendee-list-string', { name: this.attendees[0].name, count: this.attendees.length - 1 });
      }
    },
    initTimeData () {
      this.meetingTimeList = [];
      let interval = 30;
      let nearestFuture = Util.nearestFutureMinutes(interval, moment());
      let time = nearestFuture.clone();
      let endDate = time.clone().add(1, 'day').format('YYYY-MM-DD');
      while (time.format('YYYY-MM-DD') < endDate) {
        this.meetingTimeList.push(time.format('HH:mm'));
        time = time.add(interval, 'minutes');
      }
      this.endTime = nearestFuture.add(1, 'hours').format('HH:mm');
      if (!this.meetingTimeList.find(t => t === this.endTime)) {
        this.endTime = this.meetingTimeList[this.meetingTimeList.length - 1];
      }
    },
    getOpenConfInfo (meetingId) {
      let params = {
        meetingId: meetingId
      };
      this.$http.get(`/api/v1/meetings/openConference`, { params: params }).then((response) => {
        let ret = response.data;
        this.editRoomInfo = ret[0];
        this.roomName = this.editRoomInfo.name;
      }).catch(error => {
        console.log(error);
      });
    },
    submitReserve () {
      let endDtime = moment.tz(this.endDate + ' ' + this.endTime, moment.tz.guess()).utc().format();
      // 미팅 예약
      let meetingInfo = {
        creator: {
          email: this.$store.state.user.email,
        },
        title: this.title,
        endDtime: endDtime,
        attendees: this.attendees,
        meetingPW: this.meetingPW,
        siteName: this.$store.state.user.siteName,
        openConfId: this.room._id
      };

      let now = moment().utc().format();
      if (now >= endDtime) {
        Util.snackBarOpen(this.$t(`page.meeting-reserve.end-time-error`), 'error');
        this.error = this.$t(`page.meeting-reserve.end-time-error`);
        return;
      }

      this.loading = true;
      this.$http.post(`/api/v1/meetings/openConference`, meetingInfo).then((response) => {
        let ret = response.data;
        this.loading = false;
        if (!ret.success) {
          console.log(ret.message);
        } else {
          this.close(true);
          Util.snackBarOpen(this.$t('page.system-mgr.meeting-composition.add-meeting-msg'), 'success');
        }
      }).catch(error => {
        console.log(error);
      });
      // alert('기능 개발중');
    },
    changedEndTime () {
      console.log(`changedEndTime`);
    },
    openMeetingInvitaionDialog () {
      this.meetingInvitaionDialog.dialog = true;
      this.meetingInvitaionDialog.attendees = this.attendees;
    },
    closeMeetingInvitaionDialog (attendees) {
      this.meetingInvitaionDialog.dialog = false;
      if (attendees) {
        if (attendees.length === 1) {
          this.attendeesString = `${attendees[0].name}`;  
        }
        else if (attendees.length > 1) {
          this.attendeesString = this.$t('page.meeting-reserve.attendee-list-string', { name: attendees[0].name, count: attendees.length - 1 });
        } 

        // let datalist = attendees.map(item => {
        //   return item.email;
        // });
          
        this.attendees = attendees;
      }
    },
    async editMeeting () {
      let endDtime = moment.tz(this.endDate + ' ' + this.endTime, moment.tz.guess()).utc().format();
      // 미팅 예약
      let meetingInfo = {
        creator: {
          email: (this.isAdminPage ? this.meetingInfo.creator.email : this.$store.state.user.email),
        },
        title: this.title,
        endDtime: endDtime,
        attendees: this.attendees,
        meetingPW: this.meetingPW,
        siteName: this.$store.state.user.siteName,
        openConfId: this.editRoomInfo._id,
        meetingId: this.meetingInfo._id,
        meetingKey: this.meetingInfo.meetingKey
      };
      
      let now = moment().utc().format();
      if (now >= endDtime) {
        Util.snackBarOpen(this.$t(`page.meeting-reserve.end-time-error`), 'error');
        this.error = this.$t(`page.meeting-reserve.end-time-error`);
        return;
      }

      this.loading = true;
      this.$http.put(`/api/v1/meetings/openConference/${meetingInfo.meetingId}`, meetingInfo).then((response) => {
        let ret = response.data;
        this.loading = false;
        if (!ret.success) {
          console.log(ret.message);
        } else {
          this.close(true);
          Util.snackBarOpen(this.$t('page.system-mgr.meeting-composition.add-meeting-msg'), 'success');
        }
      }).catch(error => {
        console.log(error);
      });
    },
    async deleteMeeting () {
      // 미팅 삭제
      let params = {
        meetingKeys: [this.meetingInfo.meetingKey]
      };
      await this.$http.delete('/api/v1/meetings', { params: params }).then(response => {
        if (response.data === 'ok') {
          this.close(true);
          Util.snackBarOpen(this.$t('page.system-mgr.meeting-composition.delete-meeting-msg'), 'success');
        }
      }).catch(error => {
        console.log(error);
      });
    },
    close (isInit) {
      this.closeDialog(isInit);
    }
  }
};
</script>
<style scoped>
.formbox-time-select{
  width: 106px;
  height: 38px;
  border-radius: 4px;
  border: 1px solid #7f7f7f;
  text-align: left;
  font-size: 16px;
  color: #7f7f7f;
  font-weight: 400;
  background: #fff;
  letter-spacing: -1px;
  padding-left: 12px;
  background-image: url(/static/webex-cloud/images/common/time_ico.png), url(/static/webex-cloud/images/common/selar.png);
  background-position: 70% 52%, 87% 52%;
  background-repeat: no-repeat, no-repeat;
  
  /* background: url(/static/webex-cloud/images/common/selar.png) no-repeat 87% 52%;
  background: url(/static/webex-cloud/images/common/selar.png) no-repeat 25% 52%; */
}

.pop_tit{
  height: 20px;
  padding: 30px 0 10px;
  color: #444;
  text-align: left;
  letter-spacing: -1px;
  font-size: 25px;
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
}
.pop_close{
  position: absolute;
  top: 20px;
  right: 20px;
  display:inline-block;
  width:15px;
  height:15px;
  text-indent: -9999px;
  background: url(/static/webex-cloud/images/common/close_btn.png) center center no-repeat;
}

.popContainer { 
  padding: 0px 60px 40px 60px;
  min-height: 200px;
  padding: 0px 60px 40px 60px;
  background: #fff;
  font-size: 16px;
  height: 450px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/OpenConferenceCreateDialog.vue